<template>
  <div>
    <el-dialog :title="$t('lang.设置货币')" :visible.sync="dialogVisible">
      <el-input
        :placeholder="$t('lang.请输入国家名称或币种名称')"
        prefix-icon="el-icon-search"
        v-model="queryName"
        @input="onInputQuery"
      >
      </el-input>
      <el-table :data="tableDataCom" height="230">
        <el-table-column :label="$t('lang.国家币种')" align="center">
          <template slot-scope="scope">
            <span>{{
              `${
                $i18n.locale == "zh-CN"
                  ? scope.row.nationNameZh
                  : scope.row.nationNameEn
              }(${scope.row.currencyCode})`
            }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('lang.操作')" align="center">
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.selected"
              @change="onChangeCheckbox(scope.row)"
            ></el-checkbox>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">
          {{ $t("lang.取消") }}
        </el-button>
        <el-button type="primary" @click="onClickSubmitted">
          {{ $t("lang.保存") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      tableData: [],
      tableDataCopy: [],
      selectedItem: "",
      queryName: "",
    };
  },
  computed: {
    tableDataCom: function () {
      return this.tableDataCopy.map((item) => ({
        ...item,
        selected: false,
      }));
    },
  },
  methods: {
    ...mapActions({
      countryConfigurationList: "ZD_CountryConfigurationList",
      nationalSettings: "ZD_NationalSettings",
    }),
    async showDialog() {
      this.dialogVisible = true;
      let areaCode = this.$store.getters["areaCode/countriesAndRegions"];
      if (!this.isnull(areaCode)) {
        this.tableData = areaCode;
        this.tableDataCopy = this.docopy(areaCode);
        this.activeState();
        return;
      }
      let res = await this.countryConfigurationList({});
      if (res.success !== 1) return;
      this.tableData = res.listItem;
      this.tableDataCopy = this.docopy(res.listItem);
      this.$store.commit("areaCode/countriesAndRegions", res.listItem);
      this.activeState();
    },
    activeState() {
      this.tableDataCom.forEach((item) => {
        if (item.id == localStorage.getItem("nationId")) {
          item.selected = true;
        }
      });
    },
    onChangeCheckbox(row) {
      this.selectedItem = row;
      this.tableDataCom.forEach((item) => {
        item.selected = false;
      });
      row.selected = true;
    },
    async onClickSubmitted() {
      if (this.selectedItem == "")
        return this.$message.warning(this.$t("lang.当前选择已设置"));
      let res = await this.nationalSettings({ id: this.selectedItem.id });
      if (res.success !== 1) return;
      // 货币符号
      localStorage.setItem("monetary", this.selectedItem.currencyCode || "元");
      localStorage.setItem("nationId", this.selectedItem.id);
      if (this.$route.path == "/priceControl") {
        this.$bus.$emit("updateCurrency", this.selectedItem.currencyCode);
      } else if (this.$route.path == "/collectionDetails") {
        this.$bus.$emit("updateCurrency2", this.selectedItem.currencyCode);
      }
      this.$message.success(this.$t("lang.设置成功"));
      this.dialogVisible = false;
    },
    onInputQuery(val) {
      const searchValue = val.trim().toLowerCase();
      this.tableDataCopy = this.tableData.filter((item) => {
        return (
          item.nationNameZh.includes(searchValue) ||
          item.nationNameEn.toLowerCase().includes(searchValue) ||
          item.currencyCode.toLowerCase().includes(searchValue)
        );
      });
    },
  },
  destroyed() {
    this.$bus.$off("updateCurrency");
    this.$bus.$off("updateCurrency2");
  },
};
</script>

<style scoped lang='less'>
/deep/.el-dialog {
  width: 867px;
  margin-top: 48vh !important;
}
.el-input {
  width: 340px;
}
</style>